module.exports = __webpack_public_path__ + "static/media/meglive_flash.99f2e4c7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/image/scene/meglive_flash.mp4
// module id = 769
// module chunks = 0